
import { useContext } from 'react';
import './style/productComponent.css';
import { AppContext } from '../../../contextApi/ContextApi';
import ProductInfo from './ProductInfo';
import ProductComponent_content from './ProductComponent_content';
import ProductComponentRibbon from './ProductComponentRibbon';

export default function ProductComponent({ website, val, inx, isDashboard, setDisplay }) {
  const { primary_color, accent_color } = useContext(AppContext);
  return (
    <div className='productComp_mainContainer' style={{backgroundColor:primary_color, border:`0.5px solid ${accent_color}`}} key={`productComponentKey_${inx}`}>
      <ProductInfo val={val} inx={inx}/>
      <ProductComponentRibbon val={val} inx={inx}/>
      <ProductComponent_content website={website} val={val} isDashboard={isDashboard} setDisplay={setDisplay}/>
    </div>
  )
}
